module.exports = function() {
  return new Worker(__webpack_public_path__ + "4a3c9b2f5c17d71a0921.worker.js");
};